<section id="section-report" class="container-fluid mt-1 ">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page " id="preview-cash-receipt" *ngFor=" let  cashReceiptModel of cashReceiptModels">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{cashReceiptModel.cashReceiptId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{cashReceiptModel.cashReceiptId}}" [src]="logoEnterprise" alt="logo de la empresa"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.enterpriseName}}</p>

                  <!--Nit  -->
                  <label id="t-nit-empresa-{{cashReceiptModel.cashReceiptId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-nit-empresa' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-empresa-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.enterpriseNit}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{cashReceiptModel.cashReceiptId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{cashReceiptModel.cashReceiptId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.branchPhone}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{cashReceiptModel.cashReceiptId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.clientDocumentName}}</p>

                  <!-- Descripción -->
                  <label id="t-descripcion-{{cashReceiptModel.cashReceiptId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-descripcion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="descripcion-{{cashReceiptModel.cashReceiptId}}" class="lh-1" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.description}}</p>

                  <!--Concepto Ingreso -->
                  <label id="t-concepto-ingreso-{{cashReceiptModel.cashReceiptId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-concepto-ingreso' | formatLabelPipe : elementsLabel}}</label>
                  <p id="concepto-ingreso-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.incomeConceptCodeName}}</p>

                  <!-- Valor -->
                  <label id="t-valor-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-valor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.totalValue | currency:'':'' }}</p>

                  <!--titulo-recibo de caja  -->
                  <p id="titulo-recibo-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">RECIBO DE CAJA</p>

                  <!--consecutivo  -->
                  <p id="consecutivo-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{ 'No.' +cashReceiptModel.consecutive}}</p>

                  <!-- Fecha  -->
                  <label id="t-fecha-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{cashReceiptModel.dateCashReceipt | date: 'dd/MM/yyyy'}}</p>

                  <!-- Total Pagado  -->
                  <label id="t-total-pagado-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-total-pagado' | formatLabelPipe : elementsLabel}}</label>
                  <p id="total-pagado-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    <ng-container *ngIf="getLabelPrintFormat('total-pagado'); else currencyFormatTotalPagado">
                      {{ cashReceiptModel.totalPaidValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('total-pagado') }}
                    </ng-container>
                    <ng-template #currencyFormatTotalPagado>
                      {{ cashReceiptModel.totalPaidValue | currency }}
                    </ng-template>
                  </p>

                  <!-- Anticipos -->
                  <label id="t-anticipos-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-anticipos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="anticipos-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    <ng-container *ngIf="getLabelPrintFormat('anticipos'); else currencyFormatAnticipos">
                      {{ cashReceiptModel.advanceValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('anticipos') }}
                    </ng-container>
                    <ng-template #currencyFormatAnticipos>
                      {{ cashReceiptModel.advanceValue | currency }}
                    </ng-template>
                  </p>

                  <!-- Reembolso -->
                  <label id="t-reembolso-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-reembolso' | formatLabelPipe : elementsLabel}}</label>
                  <p id="reembolso-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    <ng-container *ngIf="getLabelPrintFormat('reembolso'); else currencyFormatReembolso">
                      {{ cashReceiptModel.refundValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('reembolso') }}
                    </ng-container>
                    <ng-template #currencyFormatReembolso>
                      {{ cashReceiptModel.refundValue | currency }}
                    </ng-template>
                  </p>

                  <!-- Aprovechamiento -->
                  <label id="t-aprovechamiento-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-aprovechamiento' | formatLabelPipe : elementsLabel}}</label>
                  <p id="aprovechamiento-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    <ng-container *ngIf="getLabelPrintFormat('aprovechamiento'); else currencyFormatAprovechamiento">
                      {{ cashReceiptModel.utilizationValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('aprovechamiento') }}
                    </ng-container>
                    <ng-template #currencyFormatAprovechamiento>
                      {{ cashReceiptModel.utilizationValue | currency }}
                    </ng-template>
                  </p>

                  <!-- Valor total -->
                  <label id="t-valor-total-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-valor-total' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-total-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    <ng-container *ngIf="getLabelPrintFormat('valor-total'); else currencyFormatValorTotal">
                      {{ cashReceiptModel.totalValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('valor-total') }}
                    </ng-container>
                    <ng-template #currencyFormatValorTotal>
                      {{ cashReceiptModel.totalValue | currency }}
                    </ng-template>
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container" *ngIf="cashReceiptModel.invoiceCashReceipts.length > 0">
                <app-custom-table-print id="factura-recibo-caja-{{cashReceiptModel.cashReceiptId}}" [columns]="columns"
                  [data]="cashReceiptModel.invoiceCashReceipts" [idMap]="idMap"
                  [documentId]="cashReceiptModel.cashReceiptId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <div class="table-way-to-pay mt-3" *ngIf="cashReceiptModel.cashReceiptPayments.length > 0">
                <app-custom-table-print id="forma-pago-{{cashReceiptModel.cashReceiptId}}" [columns]="columnsWayToPay"
                  [data]="cashReceiptModel.cashReceiptPayments" [idMap]="idMapWayToPay"
                  [documentId]="cashReceiptModel.cashReceiptId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorderWayToPay($event)"></app-custom-table-print>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Obseervación  -->
          <div id="foot-{{cashReceiptModel.cashReceiptId}}" class="foot mt-1 container-observations">
            <label id="t-observación-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()" *ngIf="cashReceiptModel.observation">
              {{'t-observación' | formatLabelPipe : elementsLabel}}</label>
            <p id="observación-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)" class="lh-1"
              (dragstart)="onDragStart()" *ngIf="cashReceiptModel.observation">{{cashReceiptModel.observation}}</p>

            <!-- Firma Elaboro -->
            <p id="linea-firma-elaboro-{{cashReceiptModel.cashReceiptId}}" class="write-line "
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-firma-elaboro-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-firma-elaboro' | formatLabelPipe : elementsLabel}}</label>

            <!-- Firma reviso -->
            <p id="linea-firma-reviso-{{cashReceiptModel.cashReceiptId}}" class="write-line "
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-reviso-{{cashReceiptModel.cashReceiptId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-linea-reviso' | formatLabelPipe : elementsLabel}}</label>
          </div>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{cashReceiptModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>